import { useContext } from 'react'
import { AuthenticationContext } from '../AuthenticationContext'

/**
 * Service Tickets is being sunset: tenants that had it keep it indefinitely, tenants created
 * after the cutoff never get it. The server owns the cutoff and ships the answer on the tenant,
 * so the date is not restated here.
 *
 * Defaults to true while the account is loading, so a legacy tenant never flickers into a
 * state where the feature looks gone.
 */
const useServiceTicketsEnabled = (): boolean => {
  const { currentUser } = useContext(AuthenticationContext)
  return currentUser?.tenant.serviceTicketsEnabled ?? true
}

export default useServiceTicketsEnabled
